import {Grid, Paper, Typography} from "@mui/material";
import React from "react";
import { pageContentGap } from "../../../../../theme";

// region TypeScript Interfaces
export interface ProductDetailProps {
    listkey?: number | string;
    id?: string;
    paperStyles?: React.CSSProperties;
    hideTitle?: boolean;
    titleAlignItems?: string;
    titleActions?: React.ReactNode;
    titleStyles?: React.CSSProperties;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    contentStyles?: React.CSSProperties;
    content: React.ReactNode;
}
// endregion

export const ProductDetail = (props: ProductDetailProps) => {
    return (
        <Paper key={props.listkey} id={props.id} style={{width: "100%", ...props.paperStyles}}>
            <div style={{
                borderRadius: "6px",
                width: "100%",
                backgroundColor: "white",
                padding: "12px",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                gap: pageContentGap
            }}>
                {!props.hideTitle && (
                    <Grid container spacing={0} alignItems={(props.titleAlignItems as any) || "center"}>
                        <Grid item container size={props.titleActions ? 6 : 12} justifyContent={"flex-start"} alignItems={"center"}>
                            <Typography component={'span'} style={{fontSize: "20px", fontWeight: "700", ...props.titleStyles}}>
                                {props.title}
                            </Typography>
                            {props.subtitle && (
                                <Grid item size={12}>
                                    {props.subtitle}
                                </Grid>
                            )}
                        </Grid>

                        {props.titleActions && (
                            <Grid container size={6} justifyContent={"flex-end"} alignItems={"center"}
                                  style={{gap: pageContentGap}}>
                                {props.titleActions}
                            </Grid>
                        )}
                    </Grid>
                )}

                <Grid container spacing={0} style={{width: "100%", ...props.contentStyles}}>
                    {props.content}
                </Grid>
            </div>
        </Paper>
    );
}
